import { Outlet } from 'react-router-dom';

export default function Methods() {
    return (
        <Outlet />
    )
}
